import { SplitTestStatus } from "testly-web/queries";

export const actionsNameInPastMap: Record<SplitTestStatus, string> = {
  [SplitTestStatus.Active]: "activated",
  [SplitTestStatus.Paused]: "paused",
  [SplitTestStatus.Finished]: "finished",
  [SplitTestStatus.Draft]: "put in draft"
};
